// removed by extract-text-webpack-plugin
module.exports = {"Container":"_TOUQm","Nav":"_2BlS2","Image":"_Dd_u1","BaggageRight":"_3Inpp","BaggageSelect":"_khiCB"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Addons/Baggage/Baggage.scss
// module id = 596
// module chunks = 0